import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MensagemControleListaComponent } from './mensagem-controle-lista/mensagem-controle-lista.component';
import { MensagemControleExecutarPendentesComponent } from './mensagem-controle-executar-pendentes/mensagem-controle-executar-pendentes.component';


const routes: Routes = [
  { path: 'mensagemControle/listar', component: MensagemControleListaComponent, data: { titulo: 'Controle de mensagens' }  },
  { path: 'mensagemControle/executarPendentes', component: MensagemControleExecutarPendentesComponent, data: { titulo: 'Execução de Mensagens com Erro' }  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MensagemControleRoutingModule { }
